"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefined = void 0;
/**
 * Removes undefined immediate and nested attributes object
 * to prevent serializable Next errors
 *
 * @link https://github.com/vercel/next.js/discussions/11209
 * @param {object|array} input
 * @return {object|array}
 */
const removeUndefined = (input) => {
    return JSON.parse(JSON.stringify(input));
};
exports.removeUndefined = removeUndefined;
exports.default = exports.removeUndefined;
//# sourceMappingURL=removeUndefined.js.map